export default class AreaDownload {
	constructor(node) {
		this.node = node;

		this.listingFiles = node.querySelector('.listing-download .step-files');
		this.listingCataloghiNode = node.querySelector('.listing-download .step-cataloghi');

		this.filtriNode = node.querySelector('.area-download__filtri');
		this.filtroTipoNode = this.filtriNode.querySelector('#type-file');
		this.filtroFamigliaNode = this.filtriNode.querySelector('#type-famiglia');
		this.filtroProdottoNode = this.filtriNode.querySelector('#type-prodotto');
		this.filtroCatalogoNode = this.filtriNode.querySelector('#type-catalogo');

		this.abstractNode = node.querySelector('.abstract');

		if (this.filtroTipoNode.querySelector('[selected]')) {
			this.pushHistory(this.filtroTipoNode.querySelector('[selected]').dataset.url);
		} else {
			this.pushHistory(this.filtroTipoNode.querySelector('option').dataset.url);
		}

		this.addListeners();
	}

	addListeners() {
		let _this = this;

		// Filtro primo livello.
		this.filtroTipoNode.addEventListener('change', function() {
			let responseData = {};

			let submittedData = {
				data: {
					tipoFile: this.value
				}
			};

			_this.hideAllFilters();
			_this.hideAllListings();

			_this.showAbstractText();

			_this.pushHistory(this.querySelector('[value="' + this.value + '"]').dataset.url);

			if (this.value === "cataloghi") {
				_this.showFilter(_this.filtroCatalogoNode);

				// filtro Cataloghi è già valorizzato server-side.
			} else if (this.value === "file2d" || this.value === "scheda-montaggio") {
				$.ajax({
					type: "POST",
					url: "/WS/wsAreaDownload.asmx/GetCategorieFile",
					cache: false,
					contentType: "application/json; charset=utf-8",
					data: JSON.stringify(submittedData),
					dataType: "json",
					success: function(data) {
						responseData = data;

						let options = JSON.parse(responseData.d.HTML);
						_this.updateSelect(_this.filtroFamigliaNode, options);
						_this.showFilter(_this.filtroFamigliaNode);
					},
					error: function(data) {
						responseData = data;
					},
					complete: function() {
						// console.log(responseData);
					}
				});
			}
		});

		this.filtroCatalogoNode.addEventListener('change', function() {
			if (this.value === "") {
				return;
			}

			let responseData = {};

			let submittedData = {
				data: {
					valoreFiltro: this.value
				}
			};

			_this.clearListingCataloghi();

			$.ajax({
				type: "POST",
				url: "/WS/wsAreaDownload.asmx/GetListaCataloghi",
				cache: false,
				contentType: "application/json; charset=utf-8",
				data: JSON.stringify(submittedData),
				dataType: "json",
				success: function(data) {
					responseData = data;

					let cataloghi = JSON.parse(responseData.d.HTML);
					_this.updateListingCataloghi(cataloghi);
					_this.showListing(_this.listingCataloghiNode);
				},
				error: function(data) {
					responseData = data;
				},
				complete: function() {
					// console.log(responseData);
				}
			});
		});

		this.filtroFamigliaNode.addEventListener('change', function() {
			if (this.value === "") {
				return;
			}

			let responseData = {};

			let submittedData = {
				data: {
					tipoFile: _this.filtroTipoNode.value,
					valoreFiltro: this.value
				}
			};

			_this.hideAllListings();
			_this.updateSelect(_this.filtroProdottoNode, []);

			$.ajax({
				type: "POST",
				url: "/WS/wsAreaDownload.asmx/GetListaProdotti",
				cache: false,
				contentType: "application/json; charset=utf-8",
				data: JSON.stringify(submittedData),
				dataType: "json",
				success: function(data) {
					responseData = data;

					let options = JSON.parse(responseData.d.HTML);
					_this.updateSelect(_this.filtroProdottoNode, options);
					_this.showFilter(_this.filtroProdottoNode);
				},
				error: function(data) {
					responseData = data;
				},
				complete: function() {
					// console.log(responseData);
				}
			});
		});

		this.filtroProdottoNode.addEventListener('change', function() {
			if (this.value === "") {
				return;
			}

			let responseData = {};

			let submittedData = {
				data: {
					tipoFile: _this.filtroTipoNode.value,
					valoreFiltro: this.value
				}
			};

			_this.clearAllListings();

			$.ajax({
				type: "POST",
				url: "/WS/wsAreaDownload.asmx/GetFileProdotto",
				cache: false,
				contentType: "application/json; charset=utf-8",
				data: JSON.stringify(submittedData),
				dataType: "json",
				success: function(data) {
					responseData = data;

					let downloadItems = JSON.parse(responseData.d.HTML);

					_this.updateListingFiles(downloadItems);
					_this.showListing(_this.listingFiles);
				},
				error: function(data) {
					responseData = data;
				},
				complete: function() {
					// console.log(responseData);
				}
			});
		});

		window.addEventListener('popstate', function(event) {
			if (event.state && event.state.type != undefined && event.state.type === 'download') {
				let selectedOption = _this.filtroTipoNode.querySelector('option[data-url="' + event.state.url + '"]');

				_this.filtroTipoNode.options[selectedOption.index].selected = true;
				_this.filtroTipoNode.dispatchEvent(new Event('change'));
			}
		});
	}

	pushHistory(url) {
		if (!history.state || history.state.url != url) {
			history.pushState({ type: 'download', url: url }, "", url);
		}
	}

	updateListingCataloghi(cataloghi) {
		let tplListingItem = this.listingCataloghiNode.querySelector('[data-tpl-download-file]').cloneNode(true);
		tplListingItem.removeAttribute('data-tpl-download-file');
		tplListingItem.removeAttribute('style');

		for (let id in cataloghi) {
			let catalogo = cataloghi[id];

			// console.log(catalogo);

			var catalogoNode = tplListingItem.cloneNode(true);

			catalogoNode.querySelector('.cover .nome-file').innerHTML = catalogo.title;
			catalogoNode.querySelector('.cover img').setAttribute("src", catalogo.thumb);
			catalogoNode.querySelector('.download a').setAttribute("href", catalogo.fileURL);

			this.listingCataloghiNode.querySelector(".listing-file").appendChild(catalogoNode);
		}
	}

	clearListingCataloghi() {
		this.listingCataloghiNode.querySelector('.listing-file').innerHTML = '';
	}

	clearListingFiles() {
		this.listingFiles.querySelector('.file-list').innerHTML = "";
	}

	clearAllListings() {
		this.clearListingCataloghi();
		this.clearListingFiles();
	}

	updateListingFiles(files) {
		let tplListingItem = this.listingFiles.querySelector('[data-tpl-download-file]').cloneNode(true);
		tplListingItem.removeAttribute('data-tpl-download-file');
		tplListingItem.removeAttribute('style');

		for (let id in files) {
			let file = files[id];

			let fileNode = tplListingItem.cloneNode(true);

			fileNode.querySelector('.filename').innerHTML = file.fileName;
			fileNode.querySelector('.download a').setAttribute("href", file.fileURL);

			this.listingFiles.querySelector(".file-list").appendChild(fileNode);
		}
	}

	showListing(listingNode) {
		listingNode.style.display = "block";
	}

	hideListing(listingNode) {
		listingNode.style.display = "none";
	}

	hideAllListings() {
		this.node.querySelectorAll('.listing-download .step').forEach(function(listingNode) {
			listingNode.style.display = "none";
		});
	}

	showAbstractText() {
		if (window.areaDownload.abstracts[this.filtroTipoNode.value] !== undefined) {
			this.abstractNode.innerHTML = window.areaDownload.abstracts[this.filtroTipoNode.value];
		} else {
			this.abstractNode.innerHTML = "";
		}

		this.abstractNode.style.display = "block";
	}

	showFilter(filterNode) {
		filterNode.style.display = "block";
	}

	hideFilter(filterNode) {
		filterNode.style.display = "none";
	}

	hideAllFilters() {
		// Nasconde tutti i filtri (tranne il primo livello).
		this.filtriNode.querySelectorAll('select:not(#type-file)').forEach(function(filtroNode) {
			filtroNode.style.display = "none";
			filtroNode.querySelector('option:first-child').selected = 'selected';
		});
	}

	updateSelect(selectNode, options) {
		selectNode.options.length = 1;

		for (let id in options) {
			let option = document.createElement("option");

			option.value = options[id].id;
			option.text = options[id].name;

			selectNode.add(option);
		}
	}

	static init() {
		let areaDownloadNode = document.querySelector("[data-area-download]");

		if (areaDownloadNode) {
			return new AreaDownload(areaDownloadNode);
		}
	}
}
